import type { CustomFieldBasicSettingProvider } from '../models';

function isKeyUsedAsCustomMst(
  customFieldKey: string | undefined,
  customFieldBasicSettings: CustomFieldBasicSettingProvider[],
) {
  const customFieldKeyNumber = Number(customFieldKey);
  if (isNaN(customFieldKeyNumber)) {
    return false;
  } else {
    const targetSetting = customFieldBasicSettings.find((s) => s.key === customFieldKeyNumber);

    return targetSetting?.attribute === '1';
  }
}

export { isKeyUsedAsCustomMst };
